export default __webpack_public_path__ + "static/media/level-10.ad2f6fa0.png";